export default __webpack_public_path__ + "static/media/chevron-left.c21db314.svg";